// ============================================
// ProfilePictureModal — the "Profile picture" options sheet
// Choose an avatar · Upload your own photo · Use my photo · Remove profile picture
// The backend decides which image is active (curated > uploaded > default).
// ============================================
import { useRef } from 'react';
import Modal from '../Modal/Modal';
import ProfileAvatar from './ProfileAvatar';
import styles from './AvatarPicker.module.css';

function ProfilePictureModal({ profileImage, uploadedAvatarUrl, name, busy, onClose, onChooseAvatar, onPhotoPicked, onUsePhoto, onRemove }) {
    const fileRef = useRef(null);
    const type = profileImage?.type ?? 'default';
    const canUsePhoto = type === 'curated' && Boolean(uploadedAvatarUrl);

    const handleFile = (e) => {
        const file = e.target.files?.[0];
        e.target.value = ''; // allow re-picking the same file
        if (file) onPhotoPicked(file);
    };

    return (
        <Modal isOpen onClose={busy ? () => {} : onClose}>
            <div className={styles.content}>
                <h3 className={styles.title}>Profile picture</h3>

                <div className={styles.current}>
                    <ProfileAvatar url={profileImage?.url} name={name} size={96} />
                    <span className={styles.currentLabel}>
                        {type === 'curated' ? profileImage.name : type === 'uploaded' ? 'Your photo' : 'Default'}
                    </span>
                </div>

                <div className={styles.options}>
                    <button type="button" className={styles.optionBtn} onClick={onChooseAvatar} disabled={busy}>
                        🎬 Choose an avatar
                    </button>
                    <button type="button" className={styles.optionBtn} onClick={() => fileRef.current?.click()} disabled={busy}>
                        📷 Upload your own photo
                    </button>
                    <input ref={fileRef} type="file" accept="image/*" className={styles.hiddenInput} onChange={handleFile} data-testid="profile-photo-input" />
                    {canUsePhoto && (
                        <button type="button" className={styles.optionBtn} onClick={onUsePhoto} disabled={busy}>
                            ↩️ Use my uploaded photo
                        </button>
                    )}
                    {type !== 'default' && (
                        <button type="button" className={`${styles.optionBtn} ${styles.optionDanger}`} onClick={onRemove} disabled={busy}>
                            Remove profile picture
                        </button>
                    )}
                </div>
            </div>
        </Modal>
    );
}

export default ProfilePictureModal;
